import { TableTypesState, TableTypesResponse } from './types'
import { createSlice } from '@reduxjs/toolkit'
import { getAllTableType } from './tabletype.services';

export const initialState: TableTypesState = {
    data: {} as TableTypesResponse,
    status: "loading",
    error: {}
}

export const TableTypeSlice = createSlice({
    name: 'tabletypes',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllTableType.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(getAllTableType.fulfilled, (state, action) => {
                if (action.payload) {
                    state.data = action.payload.data;
                    state.status = action.payload.status;
                    state.error = action.payload.error
                }
            })
            .addCase(getAllTableType.rejected, (state, action) => {
                state.status = 'error';
                state.error = action.error
            })
    }
})

export const TableTypeReducer = TableTypeSlice.reducer